import { useCallback } from 'react';

const useRowDragHelper = (dispatch, onRowsDrag) => {
    const onRowsDragHandler = useCallback((sourceRowsIds, targetRowId) => {
        onRowsDrag && onRowsDrag(sourceRowsIds, targetRowId);
        dispatch({ type: 'resetSelectedRows' });
    }, [onRowsDrag, dispatch]);
    return {
        onRowsDragHandler,
    };
};

export { useRowDragHelper };
//# sourceMappingURL=useRowDragHelper.js.map
